/**
 * Brand-name accessor.
 *
 * Reads `REACT_APP_BRAND_NAME` at build time (set in `.env` / docker build args)
 * and falls back to `"Orgain"` when unset. Used wherever the product/company
 * name appears in user-facing copy (titles, headers, footers, alt text, etc.).
 */
export const BRAND_NAME: string = (process.env.REACT_APP_BRAND_NAME || 'Orgain').trim() || 'Orgain';

/**
 * Default Frappe `Orgain Company` document id (the DB primary key).
 *
 * Reads `REACT_APP_DEFAULT_COMPANY_ID` at build time and falls back to
 * `"Orgain"`. Kept separate from `BRAND_NAME` because the UI label and the
 * underlying Frappe doc name can legitimately differ (e.g. a tenant rebrands
 * to "Acme" while the Frappe doc is still named "Orgain").
 */
export const DEFAULT_COMPANY_ID: string =
  (process.env.REACT_APP_DEFAULT_COMPANY_ID || 'Orgain').trim() || 'Orgain';
